import {
  ICaseWeakSignals,
  Iweak_signals,
} from "../../../pages/Fintech/FintechDashboard.type";
import {BlockToggleDescriptionTehnology} from "../../InfoExpand/blockToggleDescriptionTehnology";
import {ITypeRadar} from "../../../types";
import {TitleBlockTrend} from "../SidebarCardUI/TitleBlockTrend";
import {BlockCaseWeakSignals} from "../SidebarCardUI/BlockCaseWeakSignals";
import {TitleCard} from "../styles";

interface IProps {
  data: Iweak_signals;
  typeRadar?: ITypeRadar;
  colorTitle?: string;
}

const SideBarContentFintechWeakSignals: React.FC<IProps> = ({
  data,
  typeRadar,
  colorTitle,
}) => {
  if (!data) {
    return <>Грузим данные</>;
  }

  const blockCase: ICaseWeakSignals = {
    case_name: data.case_name,
    case_url: data.case_url,
    case_details: data.case_details,
  };
  return (
    <div>
      <TitleCard color={colorTitle}>{data?.title}</TitleCard>
      <br />
      <BlockToggleDescriptionTehnology
        data={data.description}
        title={<TitleBlockTrend title="Описание" />}
        isOpen
        typeRadar={typeRadar}
      />
      <br />
      <BlockToggleDescriptionTehnology
        data={<BlockCaseWeakSignals dataCases={blockCase} />}
        title={<TitleBlockTrend title="Кейсы" />}
        typeRadar={typeRadar}
        isOpen
      />
    </div>
  );
};
export default SideBarContentFintechWeakSignals;
